<template>
  <div class="pre-ask-box">
    <van-nav-bar
      title="问诊信息预采集"
      left-arrow
      @click-left="onClickLeft"
      placeholder
      fixed
      :z-index="2"
    />
    <div class="form-box">
      <van-form label-width="7em" scroll-to-error @submit.prevent colon>
        <div class="ask-info form-step-box" v-watermark>
          <van-field
            name="askIllness"
            v-model="addEditData.askIllness"
            label="病情描述"
            type="textarea"
            rows="2"
            maxlength="256"
            class="line-break"
            required
          >
          </van-field>
          <van-field
            name="takeMedicineFeel"
            v-model="addEditData.takeMedicineFeel"
            label="服药感受"
            type="textarea"
            rows="2"
            maxlength="256"
            class="line-break"
          >
          </van-field>
          <van-field label="三因问卷" class="line-break">
            <template #input>
              <SelectThreeFactors
                :factorsOne.sync="addEditData.factorsOne"
                :factorsTwo.sync="addEditData.factorsTwo"
                :factorsThree.sync="addEditData.factorsThree"
              />
            </template>
          </van-field>
          <van-field
            name="threeConditionImages"
            label="舌诊照片"
            class="line-break"
            required
          >
            <template #input>
              <div class="upload-imgs">
                <div
                  v-for="(item, index) in ['眼睑', '眼睑', '舌苔', '舌下脉络']"
                  :key="index"
                  class="upload-item"
                >
                  <div class="upload-title">
                    <div>
                      {{ { 0: "左眼", 1: "右眼" }[index] || "" }}
                    </div>
                    <div>{{ item }}</div>
                  </div>
                  <div class="upload-box">
                    <UploadImgs
                      :fileStr.sync="addEditData.threeConditionImages[index]"
                      :limit="1"
                    />
                  </div>
                </div>
              </div>
            </template>
          </van-field>
        </div>
      </van-form>
    </div>
    <div class="bottom-box safe-area-inset-bottom">
      <div class="bottom-container">
        <van-button
          type="info"
          @click="onSaveForm"
          class="button-box"
          :loading="loading"
          >提交</van-button
        >
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import SelectThreeFactors from "./components/selectThreeFactors.vue";
import { formatteThreeConditionImages } from "@/utils/utils";
import { setAskinfo, getAskDetail } from "@/api/index";
export default {
  name: "PreAsk",
  components: {
    SelectThreeFactors,
  },
  data() {
    return {
      addEditData: {
        askIllness: "",
        takeMedicineFeel: "",
        threeConditionImages: ["", "", "", ""], // 舌诊
        //三因
        factorsOne: [],
        factorsTwo: [],
        factorsThree: [],
      },
      loading: false,
    };
  },
  created() {
    if (this.$route.query.askNo) this.getPreAsKInfo();
  },
  computed: {
    ...mapGetters({
      threeFactorsList: "getThreeFactorsList",
      threeFactorsIndependent: "getThreeFactorsIndependent",
    }),
  },
  methods: {
    onClickLeft() {
      this.$router.back();
    },
    async onSaveForm() {
      // if (!(this.addEditData.factorsOne.length > 0 && this.addEditData.factorsTwo.length > 0 && this.addEditData.factorsThree.length > 0)) {
      //   return this.$toast('请选择三因问卷');
      // }
      if (!this.addEditData.askIllness) {
        return this.$toast("请填写病情描述");
      }
      if (
        !this.addEditData.threeConditionImages ||
        this.addEditData.threeConditionImages.length < 4 ||
        this.addEditData.threeConditionImages.some((item) => !item)
      ) {
        return this.$toast("请上传舌诊照片");
      }
      try {
        this.loading = true;
        const {
          askIllness,
          takeMedicineFeel,
          factorsOne,
          factorsTwo,
          factorsThree,
          threeConditionImages,
        } = this.addEditData;
        const imgsList = formatteThreeConditionImages(
          threeConditionImages.join(","),
          true
        );
        const params = {
          askIllness,
          takeMedicineFeel,
          threeConditionQuestionReqList: [
            ...this.threeFactorsIndependent.factorsOne.filter((item) =>
              factorsOne.includes(item.questionKewWord)
            ),
            ...this.threeFactorsIndependent.factorsTwo.filter((item) =>
              factorsTwo.includes(item.questionKewWord)
            ),
            ...this.threeFactorsIndependent.factorsThree.filter((item) =>
              factorsThree.includes(item.questionKewWord)
            ),
          ].map((item) => ({ ...item, questionRadio: 1 })), // 三因
          threeConditionImages: imgsList.join(","), // 三因图片,
          LeftBlepharImages: imgsList[0],
          blepharImages: imgsList[1],
          tongueCoatingImages: imgsList[2],
          tongueImages: imgsList[3],
        };
        await setAskinfo({
          ...params,
          isAppt: true,
          memberId: this.$route.query.userMemberId,
          doctorAssistantNo: this.$store.state.assistantNo,
          askNo: this.$route.query.askNo,
        });
        this.loading = false;
        this.$router.back();
      } catch (error) {
        console.log(error);
        this.loading = false;
      }
    },
    async getPreAsKInfo() {
      const {
        data: {
          askIllness,
          takeMedicineFeel,
          userThreeConditionQuestionList,
          threeConditionImages,
        },
      } = await getAskDetail({ askNo: this.$route.query.askNo });
      let feedbackData = {
        feedback0: [],
        feedback1: [],
        feedback2: [],
      };
      (userThreeConditionQuestionList || []).forEach((item) => {
        this.threeFactorsList.forEach((Item) => {
          if (
            item.questionType === Item.questionType &&
            item.questionKewWord === Item.questionKewWord
          )
            feedbackData[`feedback${item.questionType}`].push(
              Item.questionSubject
            );
        });
      });
      this.addEditData = {
        ...this.addEditData,
        takeMedicineFeel: takeMedicineFeel,
        askIllness: askIllness,
        threeConditionImages:
          formatteThreeConditionImages(threeConditionImages),
        factorsOne:
          feedbackData.feedback0.length === 0
            ? threeConditionImages
              ? ["暂无以上症状"]
              : []
            : feedbackData.feedback0,
        factorsTwo:
          feedbackData.feedback1.length === 0
            ? threeConditionImages
              ? ["暂无以上症状"]
              : []
            : feedbackData.feedback1,
        factorsThree:
          feedbackData.feedback2.length === 0
            ? threeConditionImages
              ? ["暂无以上症状"]
              : []
            : feedbackData.feedback2,
      };
    },
  },
};
</script>
<style lang="scss" scoped>
:deep(.disease-box) {
  display: flex;
  flex-wrap: wrap;
  line-height: normal;

  .disease-item {
    padding: 4px 9px;
    background: #eff3fb;
    border: 1px solid #0082ef;
    color: #0082ef;
    border-radius: 4px;
    margin-right: 10px;
    margin-top: 10px;
  }
}

.base-button {
  background: #0082ef;
  border-radius: 4px;
  padding: 5px 18px;
  color: #fff;
  cursor: pointer;
  text-align: center;
  line-height: normal;
  position: absolute;
  top: -30px;
  right: 0;
}

.pre-ask-box {
  padding-bottom: 100px;
  background: #ffffff;
  min-height: 100vh;

  .bottom-box {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    border-radius: 0px 0px 0px 0px;
    z-index: 10;
    background: #ffffff;

    .bottom-container {
      height: 84px;
      background: #ffffff;
      box-sizing: border-box;
      padding: 16px 25px;
      display: flex;

      .button-box {
        width: 100%;
        height: 50px;
        background: #0082ef;
        border-radius: 29px;
      }
    }
  }

  :deep(.van-nav-bar) {
    .van-nav-bar__left,
    .van-icon {
      font-size: 20px;
    }
  }

  .form-box {
    box-sizing: border-box;

    .van-field,
    .van-cell {
      background-color: transparent;
    }

    :deep(.van-field) {
      .van-field__error-message {
        text-align: right;
      }

      .van-cell__title {
        color: #333;
      }
    }

    :deep(.line-break) {
      flex-direction: column;
      position: relative;

      .van-field__label {
        width: auto !important;
      }

      .van-field__control {
        min-height: auto;
      }

      textarea {
        padding: 5px;
        position: relative;
        border: 1px solid #ccc;
        border-radius: 4px;

        &::after {
          position: absolute;
          box-sizing: border-box;
          content: " ";
          pointer-events: none;
          top: -50%;
          right: -50%;
          bottom: -50%;
          left: -50%;
          border: 0 solid #ebedf0;
          transform: scale(0.5);
          border-radius: 4px;
        }
      }
    }

    .form-step-box {
      background: #fff;

      + .form-step-box {
        margin-top: 15px;
      }
    }

    .ask-info {
      .imgs-box {
        padding: 15px 0;
      }

      .upload-imgs {
        width: 100%;
        display: flex;
        padding: 15px 0;
        flex-wrap: wrap;
        justify-content: space-between;

        .upload-item {
          overflow: hidden;
          width: 100px;

          .upload-title {
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }
      }
    }
  }
}
</style>
